import { render } from "./HomeView.vue?vue&type=template&id=12a8c04e"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=12a8c04e&lang=css"

import exportComponent from "/home/runner/work/origins-memo/origins-memo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__